export default {
  namespaced: true,
  state: () => ({ tabs: [], activeId: null, mode: 'window', restoreMode: 'window' }),
  mutations: {
    open(state, tab) {
      if (!state.tabs.some(item => item.id === tab.id)) state.tabs.push(tab)
      state.activeId = tab.id
      if (state.mode === 'minimized') state.mode = state.restoreMode
    },
    select(state, id) {
      if (!state.tabs.some(tab => tab.id === id)) return
      state.activeId = id
      if (state.mode === 'minimized') state.mode = state.restoreMode
    },
    close(state, id) {
      const index = state.tabs.findIndex(tab => tab.id === id)
      if (index === -1) return
      state.tabs.splice(index, 1)
      if (state.activeId === id) state.activeId = state.tabs[Math.min(index, state.tabs.length - 1)]?.id || null
      if (!state.tabs.length) {
        state.mode = 'window'
        state.restoreMode = 'window'
      }
    },
    setMode(state, mode) {
      if (!['window', 'fullscreen', 'minimized'].includes(mode)) return
      if (mode === 'minimized') state.restoreMode = state.mode
      state.mode = mode
    },
    clear(state) {
      state.tabs = []
      state.activeId = null
      state.mode = 'window'
      state.restoreMode = 'window'
    }
  }
}
